// import React, { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import "slick-carousel/slick/slick-theme.css";
// import "slick-carousel/slick/slick.css";
// import { dummyBrands } from "../../dummydata/dummy";
// import { getOffers } from "../../redux/features/BannerSlice";
// import { getBrand } from "../../redux/features/BrandSlice";
// import WeeklyDeals from "./WeeklyDeals";

// const Offers = () => {
//   const dispatch = useDispatch();

//   // TODO: replaced dynamic with static dummy data
//   // const brand = useSelector((state) => state.brand.brands);
//   const brand = dummyBrands;

//   const offersData = useSelector((state) => state.banner.offers)[0];

//   useEffect(() => {
//     dispatch(getBrand());
//     dispatch(getOffers());
//   }, [dispatch]);

//   const settings = {
//     // dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     arrows: false,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 1,
//           infinite: true,
//           // dots: true
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           initialSlide: 2,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   return (
//     <div className="container flex flex-col gap-gap">
//       <WeeklyDeals />

//       <div
//         className={`gap-gap border-2 ${
//           offersData?.image ? "grid lg:grid-cols-2 grid-cols-1" : ""
//         } h-fit`}
//       >
//         {/* {offersData?.image ? (
//           <Link to={"/offer-products"}>
//             <img src={offersData?.image} className="object-contain" alt="" />
//           </Link>
//         ) : null} */}
//         <div
//           className={`flex-1  ${
//             offersData?.image
//               ? "grid grid-cols-1 gap-5"
//               : "grid grid-cols-1 lg:grid-cols-2 gap-5 border-4 border-red-600"
//           }`}
//         >
//           {/* <div className="p-3 border border-gray-300 shadow-lg rounded-xl h-fit">
//             <h2 className="px-3 font-semibold md:text-2xl">Top Brands</h2>
//             {brand?.length > 2 ? (
//               <Slider {...settings} className="rounded-xl">
//                 {brand?.map((item, index) => (
//                   <div
//                     key={index}
//                     className="flex-none px-4 py-4 focus:outline-none"
//                   >
//                     <img
//                       src={item?.photo}
//                       className="object-cover w-full rounded-lg aspect-square"
//                       alt="brand"
//                     />
//                     <h2 className="px-2 mt-1">{item?.name}</h2>
//                   </div>
//                 ))}
//               </Slider>
//             ) : (
//               <div className="flex flex-wrap rounded-xl">
//                 {brand?.map((item, index) => (
//                   <div
//                     key={index}
//                     className="flex-none px-4 py-4 focus:outline-none"
//                   >
//                     <img
//                       src={item?.photo}
//                       className="object-cover rounded-lg w-28 aspect-square"
//                       alt="brand"
//                     />
//                     <h2 className="px-2 mt-1">{item?.name}</h2>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div> */}

//           <div className="hidden lg:block">
//             <WeeklyDeals />
//           </div>
//         </div>
//       </div>
//       <div className="block lg:hidden">
//         <WeeklyDeals />
//       </div>
//     </div>
//   );
// };

// export default Offers;

import { motion } from "framer-motion";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getOffers } from "../../redux/features/BannerSlice";
import WeeklyDeals from "./WeeklyDeals";

const Offers = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOffers());
  }, [dispatch]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 24,
      },
    },
  };

  return (
    <motion.div
      className="container mx-auto"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      {/* Main Offers Section */}
      <motion.div variants={itemVariants} className="">
        <WeeklyDeals />
      </motion.div>

      {/* Featured Brands Section */}
      {/* {brand?.length > 0 && (
        <motion.div variants={itemVariants} className="mb-16">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
              Featured Brands
            </h2>
            <motion.button
              className="flex items-center font-medium text-black"
              whileHover={{ x: 5 }}
              whileTap={{ scale: 0.95 }}
            >
              View All <FiArrowRight className="ml-2" />
            </motion.button>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
            {brand.slice(0, 6).map((item, index) => (
              <motion.div
                key={index}
                className="flex items-center justify-center p-4 transition-shadow duration-300 bg-white shadow-sm rounded-xl hover:shadow-md"
                whileHover={{ y: -5 }}
                variants={{
                  hidden: { scale: 0.8, opacity: 0 },
                  visible: {
                    scale: 1,
                    opacity: 1,
                    transition: {
                      delay: index * 0.05,
                      type: "spring",
                      stiffness: 300,
                      damping: 24,
                    },
                  },
                }}
              >
                <img
                  src={item.logo || "/placeholder.svg?height=80&width=120"}
                  alt={item.name}
                  className="object-contain h-12"
                />
              </motion.div>
            ))}
          </div>
        </motion.div>
      )} */}

      {/* Banner Section */}
      {/* {offersData && (
        <motion.div
          variants={itemVariants}
          className="relative overflow-hidden rounded-2xl"
        >
          <motion.div
            className="absolute inset-0 z-10 bg-gradient-to-r from-black/70 to-transparent"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          />
          <img
            src={offersData?.image || "/placeholder.svg?height=300&width=1200"}
            alt="Special Offer"
            className="object-cover w-full h-52 md:h-64"
          />
          <div className="absolute inset-0 z-20 flex flex-col justify-center p-8 md:p-12">
            <motion.h3
              className="mb-4 text-2xl font-bold text-white md:text-4xl"
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.4, type: "spring" }}
            >
              {offersData?.title || "Special Summer Collection"}
            </motion.h3>
            <motion.p
              className="max-w-md mb-6 text-white/90"
              initial={{ x: -50, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.5, type: "spring" }}
            >
              {offersData?.description ||
                "Discover our exclusive summer collection with up to 40% off on selected items."}
            </motion.p>
            <motion.button
              className="px-6 py-2 font-medium text-black bg-white rounded-full w-fit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.6 }}
            >
              Shop Now
            </motion.button>
          </div>
        </motion.div>
      )} */}
    </motion.div>
  );
};

export default Offers;
